// extracted by mini-css-extract-plugin
export default {"gw_logo":"logo-sans-nav_gw_logo__pC5j-"};